<template>
  <div id="pageNotFound">
    <span>Page not found</span>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style scoped>
#pageNotFound {
  font-size: 4rem;
  color: #20273e;
  margin-top: 15%;
  font-weight: lighter;
  opacity: 0.3;
}
</style>
